module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-62-min.786cda00.jpg";